module.exports = __webpack_public_path__ + "img/inbox.11b99c61.svg";